import { CIcon } from '~/icons/types'

export const ciToolsAccessories: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21 17.16h-.79l-1.59-6.08a4.37 4.37 0 0 0 3.88-4.307 4.39 4.39 0 0 0-4.413-4.359h-4.782a.14.14 0 0 0-.02 0h-3.024a1.794 1.794 0 0 0-1.8 1.714h-.374A2.229 2.229 0 0 0 5.853 6.29H2a.5.5 0 1 0 0 1h3.857a2.226 2.226 0 0 0 2.23 2.128h.421c.087.412.293.788.592 1.083.412.409.97.637 1.55.635h.572a2.227 2.227 0 0 0 2.234 2.177h2.066l.856 3.851h-2.51a1.5 1.5 0 0 0-1.5 1.5v1.43a1.5 1.5 0 0 0 1.5 1.5H21a1.5 1.5 0 0 0 1.5-1.5V18.66a1.5 1.5 0 0 0-1.5-1.5ZM8.456 8.417h-.369A1.229 1.229 0 0 1 6.848 7.2v-.856a1.229 1.229 0 0 1 1.239-1.216h.369v3.29Zm2.2 1.715a1.21 1.21 0 0 1-.856-.346 1.152 1.152 0 0 1-.348-.828V4.2a.8.8 0 0 1 .8-.786h2.544v6.718h-2.14Zm2.806 2.177a1.225 1.225 0 0 1-1.23-1.177h2.812l.262 1.177h-1.844Zm.348-2.177V3.414h4.282a3.36 3.36 0 0 1 0 6.718H13.81ZM16.1 11.3h1.544l1.531 5.856H17.4L16.1 11.3Zm5.4 8.786a.5.5 0 0 1-.5.5h-7.131a.5.5 0 0 1-.5-.5V18.66a.5.5 0 0 1 .5-.5H21a.5.5 0 0 1 .5.5v1.426Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'tools-accessories',
  type: 'thin'
}
